<div class="jw-modal">
  <!--
    Le corps porte le role de dialogue, pas le fond : le fond est l'element
    plein ecran qui capte le clic de fermeture, et l'annoncer comme dialogue
    ferait lire tout l'ecran a un lecteur d'ecran (RGAA 12.8).
  -->
  <div
    class="jw-modal-body"
    [class]="class"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title ? (title | translate) : null"
  >
    @if (title) {
      <h2>{{ title | translate }}</h2>
    }
    <ng-content></ng-content>
  </div>
</div>
